import BaseAPI from './base/base-api';

class ConfigAPI extends BaseAPI {
	constructor() {
		super();
	}
	urlName = 'ManagementAPI';
	controllerName = 'config';
}

export default new ConfigAPI();
